module.exports = __webpack_public_path__ + "img/address-card.9cb38773.svg";